<template>
  <div>
    <v-row class="d-flex align-center">
      <v-col cols="5" class="gl-util-interest-apportionment-report-create-misc-container">
        <FySelect
          id="glUtilInterestApportionmentCreateMiscFY"
          class="gl-util-interest-apportionment-create-misc-fy-select"
          :fyRange="fiscalYearRange"
          v-model="fiscalYearForMiscReceipt"
        />
        <v-btn
          v-if="!isPrintScreen"
          id="glUtilInterestApportionmentReportCreateMiscBtn"
          class="gl-util-interest-apportionment-report-create-misc-btn"
          depressed
          color="primary"
          @click="proceedToCreateMisc()"
        >Proceed to Create Misc</v-btn>
      </v-col>
      <v-col class="text-right">
        <v-btn
          v-if="!isPrintScreen"
          id="glUtilInterestApportionmentReportPrintReportBtn"
          class="gl-util-interest-apportionment-report-print-report-btn"
          depressed
          color="primary"
          @click="printReport()"
        >Print Report</v-btn>
      </v-col>
    </v-row>
    <v-container
      id="glUtilInterestApportionmentReportTableSection"
      class="gl-util-interest-apportionment-report-table-section"
    >
      <h2 align="center">General Ledger Interest Breakdown</h2>
      <div align="center">
        <span class="ml-4">
          {{`From: ${ toShortDate(criteriaState.fromDate) }`}}
        </span>
        <span class="ml-4">
          {{` To: ${ toShortDate(criteriaState.toDate) }`}}
        </span>
      </div>
      <hr>
      <v-simple-table
        id="glUtilInterestApportionmentReportTable"
        class="gl-util-interest-apportionment-report-table"
        dense
      >
        <template v-slot:default>
          <thead  v-if="!isPrintScreen">
            <tr>
              <th>
                Date
              </th>
              <th class="text-right">
                Basis
              </th>
              <th class="text-right"></th>
              <th class="text-right"></th>
              <th class="text-right"></th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!isPrintScreen">
            <tr
              v-for="item in endingBalanceDayWise.endingBalanceDayWise"
              :key="item.shortDate"
            >
              <td>{{ item.shortDate }}</td>
              <td class="text-right">{{ amountFormat(item.totalEndingBalance) }}</td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
            </tr>
            </template>
            <tr class="font-weight-black">
              <td>Grand Totals</td>
              <td class="text-right" id="tmc-util-apport-grand-total">
                {{ amountFormat(endingBalanceDayWise.grandTotal) }}
              </td>
              <td class="text-right">Fund Basis</td>
              <td class="text-right">Daily Average</td>
              <td class="text-right">Percent</td>
              <td class="text-right">Interest</td>
            </tr>
            <tr
              v-for="item in fundWiseInterestDetails"
              :key="item._id"
            >
              <td colspan="2">{{ item.fundDesc }}</td>
              <td class="text-right tmc-util-apport-dept-basis">
                {{ printValOrEmpty(item, amountFormat(item.accumulatedBalance)) }}
              </td>
              <td class="text-right">
                {{ printValOrEmpty(item, amountFormat(item.dailyAverage)) }}
              </td>
              <td class="text-right">
                {{ printValOrEmpty(item, (item.percentage || 0).toFixed(8)) }}
              </td>
              <td class="text-right">{{ amountFormat(item.interest) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    <hr>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapState, mapMutations } from 'vuex';
import { toShortDate, calculateFiscalYears, toFiscalYear } from '../../../util/shared/tmc-global';
import {
  amountFormat,
} from '../../../util/shared/vue-global';
import FySelect from '../../common/FySelect.vue';

export default {
  name: 'GlInterestApportionmentReport',
  components: {
    FySelect,
  },
  data: () => ({
  }),
  created() {
    this.fiscalYearForMiscReceipt = toFiscalYear(new Date(this.todaysDate));
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapGetters('base/crud', [
      'items',
      'criteria',
    ]),
    ...mapState({
      isPrintScreen: (state) => state.isPrintScreen,
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears, false);
      },
      fiscalYearFromState: (state) => state.glDaily.interestApportionment.fiscalYearForMiscReceipt,
    }),
    loadedItem() {
      return this.items(this.baseCrudKey);
    },
    endingBalanceDayWise() {
      if (this.loadedItem && this.loadedItem.endingBalanceDayWise) {
        const { endingBalanceDayWise } = this.loadedItem;
        return endingBalanceDayWise;
      }
      return {
        endingBalanceDayWise: [],
        grandTotal: 0.0,
      };
    },
    fundWiseInterestDetails() {
      if (this.loadedItem && this.loadedItem.fundWiseInterestDetails) {
        return this.loadedItem.fundWiseInterestDetails;
      }
      return [];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    fiscalYearForMiscReceipt: {
      get() {
        return this.fiscalYearFromState;
      },
      set(value) {
        this.setFiscalYearForMiscReceipt(value);
      },
    },
  },
  methods: {
    ...mapMutations([
      'setPrintScreen',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapMutations('glDaily/interestApportionment', [
      'setFiscalYearForMiscReceipt',
    ]),
    amountFormat,
    toShortDate,
    printReport() {
      /* Hide header, footer and navigation-bars */
      this.setPrintScreen(true);
      this.$nextTick(() => {
        window.print();
        this.$nextTick(() => {
          /* Show header, footer and navigation-bars */
          this.setPrintScreen(false);
        });
      });
    },
    proceedToCreateMisc() {
      this.$emit('proceedToCreateMisc');
    },
    printValOrEmpty(item, value) {
      return item.isRemainderToGeneralRecord ? '' : value;
    },
  },
};
</script>

<style>
  .gl-util-interest-apportionment-report-create-misc-container{
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-left: 2rem;
  }
</style>
